import { render, staticRenderFns } from "./IconMenuWidgets.vue?vue&type=template&id=1e4def7a&"
import script from "./IconMenuWidgets.vue?vue&type=script&lang=js&"
export * from "./IconMenuWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4def7a')) {
      api.createRecord('1e4def7a', component.options)
    } else {
      api.reload('1e4def7a', component.options)
    }
    module.hot.accept("./IconMenuWidgets.vue?vue&type=template&id=1e4def7a&", function () {
      api.rerender('1e4def7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuWidgets.vue"
export default component.exports